<template>
    <div class="main-wrapper" :class="{'push-alert': account.is_late_payment}">
        <div v-if="account.is_late_payment" id="late-payment">
            IMPORTANT: Your subscription renewal has failed. Your account will soon be downgraded to the free plan.
            <router-link :to="{ name: 'billing' }" title="Click here to upgrade your account" class="btn btn-danger-reverse">Upgrade your payment details</router-link>
        </div>
        <aside>
            <header>
                <div class="brand">
                    <router-link :to="{ name: 'dashboard' }" title="Access to your Dashboard">
                        <svg-logo />
                    </router-link>
                </div>
            </header>
            <nav>
                <ul>
                    <router-link :to="{ name: 'dashboard' }" exact title="Access to your Dashboard" tag="li">
                        <a><svg-graph /> Dashboard</a>
                    </router-link>
                    <router-link :to="{ name: 'logs' }" title="Check your logs" tag="li">
                        <a><svg-chat /> Logs</a>
                    </router-link>
                    <router-link :to="{ name: 'apikeys' }" title="Manage your API Keys" tag="li">
                        <a><svg-keys /> API Keys</a>
                    </router-link>
                    <router-link :to="{ name: 'billing' }" title="Upgrade your account" tag="li">
                        <a><svg-card /> Billing</a>
                    </router-link>
                    <router-link :to="{ name: 'invoices' }" title="Access to your Dashboard" tag="li">
                        <a><svg-dollar /> Invoices</a>
                    </router-link>
                    <router-link :to="{ name: 'settings' }" title="Access to your Dashboard" tag="li">
                        <a><svg-settings /> Settings</a>
                    </router-link>
                    <li>
                        <a href="https://docs.pdfshift.io" target="_blank" title="View our complete documentation">
                            <svg-file /> Documentation <svg-external />
                        </a>
                    </li>
                </ul>
            </nav>
            <footer>
                <a href="javascript:;" title="Click here to log out" class="logout" @click="logout"><svg-out /> Log out</a>
            </footer>
        </aside>
        <main>
            <header>
                <div>
                    Your current plan: <strong v-if="account.plan">{{ account.plan.display }}</strong><strong v-else>Free</strong>
                    <router-link :to="{ name: 'upgrade' }" title="Click here to upgrade your account" class="btn btn-light">
                        <template v-if="account.plan">Change your plan</template>
                        <template v-else>Upgrade</template>
                    </router-link>
                </div>
                <div>
                    <router-link :to="{ name: 'settings' }" title="Edit your profile" class="profile">
                        <img :src="account.avatar" :alt="`${account.firstname}'s avatar`" />
                        <span>{{ account.name || account.email }}</span>
                    </router-link>
                </div>
            </header>
            <section>
                <router-view />
            </section>
        </main>
    </div>
</template>

<script>
import SvgLogo from '@/assets/images/logo.svg'
import SvgGraph from '@/assets/images/graph.svg'
import SvgChat from '@/assets/images/chat.svg'
import SvgKeys from '@/assets/images/keys.svg'
import SvgCard from '@/assets/images/card.svg'
import SvgDollar from '@/assets/images/dollar.svg'
import SvgSettings from '@/assets/images/settings.svg'
import SvgFile from '@/assets/images/file.svg'
import SvgExternal from '@/assets/images/external.svg'
import SvgOut from '@/assets/images/out.svg'

import { mapState } from 'vuex'

export default {
    components: {
        SvgLogo, SvgGraph, SvgChat, SvgKeys, SvgCard, SvgDollar, SvgSettings, SvgFile, SvgExternal, SvgOut
    },
    computed: {
        ...mapState({
            account: state => state
        })
    },
    methods: {
        logout () {
            this.$http.post('auth/logout')
            this.$storage.remove('sessionId')
            this.$router.push({ name: 'login' })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../public/css/vars';
#late-payment {
    display: flex;
    justify-content: space-around;
    vertical-align: middle;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 10px 0;
    background-color: $form-field-error-bg-color;
    color: $danger-color;
    text-align: center;
    font-weight: bold;

    .btn-danger-reverse {
        background-color: darken($form-field-error-bg-color, 50%);
        color: #fff;
        border: none;
        box-shadow: none;
        &:hover {
            box-shadow: 2px 2px 4px fade-out(darken($form-field-error-bg-color, 50%), 0.2);
        }
    }
}

.push-alert { margin-top: 60px }
</style>
